import React from "react";
import style from "./index.module.scss";
import SignLog from "./components/SignLog";

export default function SignIn() {
    return (
        <div className={style.root}>
            <SignLog />
        </div>
    );
}
